import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as LoadingImg } from 'core/assets/images/loading.svg'
import { LoadingSpin } from './style'

function Loading({ full, height }) {
  return (
    <LoadingSpin id="loading-webpack" full={full} height={height}>
      <LoadingImg data-testid="loading-svg" />
    </LoadingSpin>
  )
}

Loading.propTypes = {
  full: PropTypes.bool,
  height: PropTypes.number,
}

Loading.defaultProps = {
  full: true,
  height: null,
}

export default memo(Loading)
